import { Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const SubscriptionGiftPaymentSummaryDetails = ({ startDate, endDate, paymentSummaryAmount, isSetup, subscriptionPeriod }: { startDate: string, endDate: string, paymentSummaryAmount: string, isSetup: boolean, subscriptionPeriod: number }) => {
    const { t } = useTranslation()

    const duration = isSetup ? t(`payment_summary_subscription_gift_duration`, { start: startDate, end: endDate }) : t(`payment_summary_subscription_duration`, { start: startDate, end: endDate })
    const title = t(`payment_summary_details_membership`)
    return (
        <Grid container direction={`row`} justifyContent={`space-between`} alignItems={`start`}>
            <Grid maxWidth={`80%`}>
                <Typography variant={`subtitle1`}>{title}</Typography>
                <Typography variant={`body2`} mb={1}>{`Subscription period: ${subscriptionPeriod} year(s)`}</Typography>
                <Typography variant={`body2`} mb={1}>{duration}</Typography>
            </Grid>
            <Typography variant={`subtitle1`}>{t(`payment_summary_amount`, { amount: paymentSummaryAmount })}</Typography>
        </Grid>
    )
}

export default SubscriptionGiftPaymentSummaryDetails